import React, { useEffect, useState } from 'react';
import { SwiperSlide } from 'swiper/react';

import { Carousel, CarouselWrapper } from '$partials/base/carousel';
import { ModuleDispatcher } from '$partials/modules';
import { Footer, Header } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ContentLandingPage}
 */
const ContentLandingPage = (props) => {
    const page = props.data.page;
    const heroModule = page.heroModule?.[0];
    const bgColor = heroModule?.backgroundColor  === 'white' ? 'bg-surface-panel-white' : `bg-surface-panel-${heroModule?.backgroundColor || 'blue'}`;
    const [ imageItems, setImageItems ] = useState(heroModule.partners);
    const [ duration, setDuration ] = useState(50);
    // hooks
    useEffect(() => {
        const handleResize = () => {

            // Duplicate messages to fill screen
            let displayedLogo = imageItems;
            while (displayedLogo.length < 5) {
                displayedLogo = displayedLogo.concat(imageItems);
            }

            // // Duplicate messages to handle overflow repeats
            const duplicateCount = 5;
            let duplicatedLogos = [];
            for (let i = 0; i < duplicateCount; i++) {
                duplicatedLogos = duplicatedLogos.concat(displayedLogo);
            }

            const totalWidth = displayedLogo.reduce((partialSum, a) => partialSum + 274, 0);
            setDuration((totalWidth / 1440 * 100) * 1.5);
            setImageItems(duplicatedLogos);
        };

        handleResize();
        window.addEventListener('resize', handleResize, { passive: true });
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <>
            <Header
                {...props?.data?.header}
                pageType={page.__typename} />

            <main id='main-content'>
                <div className='layout-container layout-site-outer-padding pb-8 md:pb-16'>
                    {/* Hero content */}
                    <div className={`${bgColor} col-wrapper-breakout rounded-lg pb-16`}>
                        <div className='col-padding pt-24 pb-16'>
                            <h1 className='type-style-sans-display'>
                                {page.title}
                            </h1>
                            {page.landingStandfirst && (
                                <h2 className='type-style-sans-h3 mt-8 w-full sm:w-9/12 md:w-1/2'>
                                    {page.landingStandfirst}
                                </h2>
                            )}
                            {heroModule && (
                                <div className='mt-24 md:mt-40 -mx-8 sm:-mx-8 md:-mx-16 overflow-hidden'>
                                    <div className='ticker relative w-full flex'>
                                        {/* Output ticker twice to fake marquee effect */}
                                        {[0, 1].map((_block, bdx) => {
                                            return (
                                                <ul
                                                    className='ticker__items w-fit h-full flex flex-shrink-0 flex-grow-0'
                                                    key={bdx}
                                                    style={{animationDuration: `${duration}s`}}>
                                                    {imageItems.map((item, idx) => {
                                                        return (
                                                            <li
                                                                className='w-[274px] px-8 ticker__item flex flex-col flex-shrink-0 flex-grow-0 justify-center whitespace-nowrap'
                                                                key={item.id}>
                                                                <div className='w-full h-[155px] relative bg-surface-raised rounded-lg overflow-hidden p-8'>
                                                                    <div
                                                                        className='w-full h-full bg-contain bg-no-repeat bg-center z-10'
                                                                        style={{
                                                                            backgroundImage: `url(${item.logo?.src})`
                                                                        }}>
                                                                    </div>
                                                                </div>
                                                                {item.name && (
                                                                    <p className='type-style-sans-body mt-[13px]'>
                                                                        {item.name}
                                                                    </p>
                                                                )}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                    {page.modules?.length > 0 && (
                        <div className='flex flex-col mt-8 md:mt-16 gap-y-8 md:gap-y-16'>
                            {page.modules.map((module, i) => (
                                <ModuleDispatcher
                                    {...module}
                                    key={i + module?.id} />
                            ))}
                        </div>
                    )}
                </div>
            </main>

            <Footer
                {...props?.data?.footer}
                exploreHide={true}
                magazineHide={true}
                pageType={page.__typename}/>
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default ContentLandingPage;
